import { render, staticRenderFns } from "./IconVideoSlash.vue?vue&type=template&id=4c83efa2&scoped=true&"
import script from "./IconVideoSlash.vue?vue&type=script&lang=js&"
export * from "./IconVideoSlash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c83efa2",
  null
  
)

export default component.exports